import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import "leaflet-polylinedecorator";

// Import local images for icons
import Tank from "../assets/images/tank.png";
import Meter from "../assets/images/Single_Water_meter.png";
import WaterMeter from "../assets/images/meterTwo.png";
import totalProducedIcon from "../assets/images/total-produced-icon.png";
import PondIcon from "../assets/images/pond.png";
import non_potable_plant_icon from "../assets/images/non-pot-plant.png";
import WellIcon from "../assets/images/gpwell.png";
import { Modal, Button } from "antd"; 
import Header from "../components/layout/Header";
import Main from "../components/layout/Main";
import back from '../assets/images/back.svg';
import { useNavigate } from 'react-router-dom';
import { get,post } from "../Libraries/Ajax/HttpService";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {Input, Space, Table, Badge, Checkbox, Tag, Spin } from 'antd';



const WaterSchematicMap = () => {
  const navigate = useNavigate();
  const dummyData = {
    waterTank: { lat: 29.922236, lng: -95.212397, name: "Water Tank" },
    well: { lat: 29.922151, lng: -95.211738, name: "GP Well" },
    non_potable_reservoir: {
      lat: 29.902653,
      lng: -95.231613,
      name: "Non-Potable Reservoir",
    },
    non_potable_plant: {
      lat: 29.901923,
      lng: -95.227709,
      name: "Non-Potable Plant",
    },
    pumps: { lat: 29.922333, lng: -95.211848, name: "Water Plant" },
    meters: [
      // {
      //   id: "95434Old",
      //   lat: 29.903853,
      //   lng: -95.231613,
      //   name: "North Distribution Old Meter",
      // },
      {
        id: "95434",
        lat: 29.922558,
        lng: -95.211764,
        name: "North Distribution Meter",
      },

      // {
      //   id: "126171Old",
      //   lat: 29.903823,
      //   lng: -95.227709,
      //   name: "South Distribution Old Meter",
      // },
      {
        id: "126171",
        lat: 29.914688,
        lng: -95.211746,
        name: "South Distribution Meter",
      },


      // { id: "101893Old", lat: 29.909853, lng: -95.233613, name: "Meter 101893 Old" },
      // { id: "162902Old", lat: 29.909853, lng: -95.223709, name: "Meter 162902 Old" },
      // { id: "150850Old", lat: 29.896379, lng: -95.16406, name: "Meter 150850L Old" },
      // { id: "150849Old", lat: 29.896379, lng: -95.16406, name: "Meter 150849H Old" },

      { id: "101893", lat: 29.923283, lng: -95.204107, name: "Meter 101893" },
      { id: "162902", lat: 29.909853, lng: -95.223709, name: "Meter 162902" },
      { id: "150850", lat: 29.896379, lng: -95.16406, name: "Meter 150850L" },
      { id: "150849", lat: 29.896379, lng: -95.16406, name: "Meter 150849H" },


      

      // { id: "106523", lat: 29.892598, lng: -95.582533, name: "Meter 106523" },
      // { id: "112651", lat: 29.919841, lng: -95.202356, name: "Meter 107215L" },
      // { id: "110645", lat: 29.923, lng: -95.2046, name: "Meter 110645H" },
      // { id: "110645", lat: 29.923, lng: -95.2046, name: "Meter 110645L" },
      // { id: "112464", lat: 29.892603, lng: -95.582553, name: "Meter 112464H" },

      // { id: "112464", lat: 29.892603, lng: -95.582553, name: "Meter 112464L" },
      // { id: "112465", lat: 29.892603, lng: -95.582553, name: "Meter 112465L" },

      // { id: "112466", lat: 29.892541, lng: -95.582613, name: "Meter 112466" },
      // { id: "112886", lat: 29.923619, lng: -95.200358, name: "Meter 112886L" },

      // { id: "112888", lat: 29.892559, lng: -95.582557, name: "Meter 112888" },
      // { id: "114473", lat: 30.010282, lng: -95.177456, name: "Meter 114473" },

      // { id: "114475", lat: 29.919206, lng: -95.217287, name: "Meter 114475" },
      // { id: "114476H", lat: 29.896379, lng: -95.16406, name: "Meter 114476H" },

      // { id: "114476L", lat: 29.896379, lng: -95.16406, name: "Meter 114476L" },
      // { id: "114477	L", lat: 29.896379, lng: -95.16406, name: "Meter 114477L" },

      // { id: "114737", lat: 29.892558, lng: -95.58254, name: "Meter 114737" },
      // { id: "116043", lat: 29.923462, lng: -95.212531, name: "Meter 116043" },

      // { id: "116044", lat: 29.920049, lng: -95.202833, name: "Meter 116044" },
      // { id: "116083", lat: 29.902783, lng: -95.222202, name: "Meter 116083" },

      // { id: "116084H", lat: 29.902783, lng: -95.222202, name: "Meter 116084H" },
      // { id: "116084L", lat: 29.902783, lng: -95.222202, name: "Meter 116084L" },

      // { id: "116085", lat: 29.902783, lng: -95.222202, name: "Meter 116085" },
      // { id: "116087", lat: 29.902783, lng: -95.222202, name: "Meter 116087" },

      // { id: "116088", lat: 29.902783, lng: -95.222202, name: "Meter 116088" },
      // { id: "116122H", lat: 29.924704, lng: -95.20672, name: "Meter 116122H" },

      // { id: "116122L", lat: 29.924704, lng: -95.20672, name: "Meter 116122L" },
      // { id: "116123", lat: 29.924704, lng: -95.20672, name: "Meter 116123" },

      // { id: "117495", lat: 29.902783, lng: -95.222202, name: "Meter 117495" },
      // { id: "126171", lat: 29.914688, lng: -95.211746, name: "Meter 126171" },

      // { id: "126507", lat: 29.923439, lng: -95.204262, name: "Meter 126507" },
      // { id: "127457", lat: 29.920838, lng: -95.203386, name: "Meter 127457" },

      // { id: "127460", lat: 29.921432, lng: -95.203626, name: "Meter 127460" },
      // { id: "129120H", lat: 29.913163, lng: -95.210984, name: "Meter 129120H" },

      // { id: "129120L", lat: 29.913163, lng: -95.210984, name: "Meter 129120L" },
      // { id: "129121", lat: 29.913163, lng: -95.210984, name: "Meter 129121" },

      // { id: "129122H", lat: 29.923584, lng: -95.212587, name: "Meter 129122H" },
      // { id: "129122L", lat: 29.923584, lng: -95.212587, name: "Meter 129122L" },

      // { id: "129123", lat: 29.923584, lng: -95.212587, name: "Meter 129123" },
      // { id: "129182", lat: 29.9235, lng: -95.2116, name: "Meter 129182" },
      // { id: "129308H", lat: 29.913111, lng: -95.222082, name: "Meter 129308H" },
      // { id: "129308L", lat: 29.913111, lng: -95.222082, name: "Meter 129308L" },
      // { id: "129310", lat: 29.913111, lng: -95.222082, name: "Meter 129310" },

      // { id: "129311", lat: 29.892563, lng: -95.582626, name: "Meter 129311" },
      // { id: "129312", lat: 29.913111, lng: -95.222082, name: "Meter 129312" },

      // { id: "129326H", lat: 29.924425, lng: -95.204783, name: "Meter 129326H" },
      // { id: "129326L", lat: 29.924425, lng: -95.204783, name: "Meter 129326L" },

      // { id: "141645H", lat: 29.927013, lng: -95.201665, name: "Meter 141645H" },
      // { id: "141645L", lat: 29.927013, lng: -95.201665, name: "Meter 141645L" },

      // { id: "142227", lat: 29.929744, lng: -95.205061, name: "Meter 142227" },
      // { id: "145270", lat: 29.923505, lng: -95.212456, name: "Meter 145270" },
      

      
    ],
    // totalProducedMeters: [
    //   { lat: 37.7705, lng: -122.419, name: "Total Produced" },
    // ],
    GenerationParkMeters :[
      // { id: "NPS2 Old", lat: 29.896379, lng: -95.16406, name: "114477/114476 Old" },
      // { id: "NPS1 Old", lat: 29.923584, lng: -95.212587, name: "129122/129123 Old" },

      { id: "NPS2", lat: 29.896379, lng: -95.16406, name: "114477/114476" },
      { id: "NPS1", lat: 29.923584, lng: -95.212587, name: "129122/129123" },

    ]
  };

  const [locations] = useState(dummyData);
  const [mapInstance, setMapInstance] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedMeter, setSelectedMeter] = useState(null);

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [res, setRes] = useState([]);
  const [nerge, setNerge] = useState([null]);
  const [weekly, setWeekly] = useState(false);
  const [regNo, setregNo] = useState('');
  const [accountname, setAccountname] = useState('');
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [addressone, setAddressone] = useState('');
  const [addresstwo, setAddresstwo] = useState('');
  const [addressthree, setAddressthree] = useState('');
  const [addressfour, setAddressfour] = useState('');
  const [meterids, setMeterids] = useState('');
  const [statuss, setStatuss] = useState('');
  const [unit, setUnit] = useState('');
  const [meterid, setMeterid] = useState('');
  const [status, setStatus] = useState('');
  const [usage, setUsage] = useState('');
  const [opensGPModal, setOpensGPModal] = useState(false);
  const [accountnames, setAccountnames] = useState('');
  const [addresss, setAddresss] = useState('');
  const [addressones, setAddressones] = useState('');
  const [addresstwos, setAddresstwos] = useState('');
  const [addressthrees, setAddressthrees] = useState('');
  const [addressfours, setAddressfours] = useState('');
  const arryDatass = [];

  useEffect(() => {
    if (L.DomUtil.get("map")) {
      L.DomUtil.get("map")._leaflet_id = null;
    }

    const map = L.map("map").setView([29.902236, -95.212397], 14);
    setMapInstance(map);

    // ✅ Using Mapbox Tile Layer
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW5hbmRodTE3IiwiYSI6ImNtN2tqcWcyeTAxYmQyaW9jZWplMTk3azIifQ.TV8rPgrmF911jPjH6ULYqA",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors &copy; <a href="https://www.mapbox.com/">Mapbox</a>',
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
      }
    ).addTo(map);

    // ✅ Icons
    const tankIcon = new L.Icon({ iconUrl: Tank, iconSize: [40, 40] });
    const wellIcon = new L.Icon({ iconUrl: WellIcon, iconSize: [45, 45] });
    const pumpIcon = new L.Icon({ iconUrl: Meter, iconSize: [40, 40] });
    const meterIcon = new L.Icon({ iconUrl: WaterMeter, iconSize: [36, 36] });
    const totalProducedIconVar = new L.Icon({
      iconUrl: totalProducedIcon,
      iconSize: [60, 60],
    });
    const reservoirIcon = new L.Icon({ iconUrl: PondIcon, iconSize: [60, 60] });
    const plantIcon = new L.Icon({
      iconUrl: non_potable_plant_icon,
      iconSize: [30, 30],
    });

    let meterMarkers = [];
    let pumpMarker = null;

    // ✅ Handle Zoom
    const handleZoom = () => {
      const zoomLevel = map.getZoom();
      // Clear all existing meter markers before re-adding them
      // meterMarkers.forEach(marker => marker.remove());
      // meterMarkers = [];

      // if (map.getZoom() <= 14) {
        if (!pumpMarker) {
          pumpMarker = L.marker([locations.pumps.lat, locations.pumps.lng], {
            icon: pumpIcon,
          })
            .addTo(map)
            .bindPopup(locations.pumps.name);
        }
        // return;
      // }

        // if (meterMarkers.length === 0) {
          locations.meters.forEach((meter,index) => {
            const offsetLat = index * 0.00010; // Small latitude shift
            const offsetLng = index * 0.00010; // Small longitude shift
            
            meterMarkers.push(
              // L.marker([meter.lat, meter.lng], { icon: meterIcon })
              L.marker([meter.lat + offsetLat, meter.lng + offsetLng], { icon: meterIcon })
                .addTo(map)
                .bindPopup(meter.name)
                .on("click", () => modalclick(meter))
                .bindTooltip(meter.name, { permanent: false, direction: "top" }) // Tooltip on hover
                
            );
          });

          locations.GenerationParkMeters.forEach((meter,index) => {
            const offsetLat = index * 0.00010; // Small latitude shift
            const offsetLng = index * 0.00010; // Small longitude shift
            
            meterMarkers.push(
              // L.marker([meter.lat, meter.lng], { icon: meterIcon })
              L.marker([meter.lat + offsetLat, meter.lng + offsetLng], { icon: meterIcon })
                .addTo(map)
                .bindPopup(meter.name)
                .on("click", () => modalclickGPark(meter))
                .bindTooltip(meter.name, { permanent: false, direction: "top" }) // Tooltip on hover
                
            );
          });
    };

    const modalclickGPark = (meter) => {
      setNerge([null]);
    
            setLoading(true);
            setOpensGPModal(true);
            setName(meter.id);
            
            get(`apis/schematic_meter?total_flow=${meter.id}`)
    
    
                .then((res) => {
    
                    console.log(res.data.data);
                    setRes(res.data.data);
                    setAccountname(res.data.data.data_meters[0].account_name);
                    setUsage(res.data.data.meter_total_converted);
                    setUnit(res.data.data.unit);
                    setMeterid(res.data.data.data_meters[0].meter_id);
                    setStatus(res?.data?.data?.data_meters[0]?.status);
                    setAddress(res.data.data.data_meters[0].location[0].location_address_line1);
                    setAddressone(res.data.data.data_meters[0].location[0].location_address_line2);
                    setAddresstwo(res.data.data.data_meters[0].location[0].location_city);
                    setAddressthree(res.data.data.data_meters[0].location[0].location_state);
                    setAddressfour(res.data.data.data_meters[0].location[0].location_zip);
                    setAccountnames(res.data.data.data_meters[1].account_name);
                    setMeterids(res.data.data.data_meters[1].meter_id);
                    setStatuss(res?.data?.data?.data_meters[1]?.status);
                    setAddresss(res.data.data.data_meters[1].location[0].location_address_line1);
                    setAddressones(res.data.data.data_meters[1].location[0].location_address_line2);
                    setAddresstwos(res.data.data.data_meters[1].location[0].location_city);
                    setAddressthrees(res.data.data.data_meters[1].location[0].location_state);
                    setAddressfours(res.data.data.data_meters[1].location[0].location_zip);
                    
                    // res.data.data.meter_flow.map((x, i) => {
                    //     console.log(x);
    
                    //     let Obj = {
                    //         name: x[0]?.option,
    
                    //         Flow: x[0]?.flow,
    
    
                    //     };
    
                    //     arryDatass.push(Obj);
    
                    //     console.log("arryDatass", arryDatass);
    
    
    
                    // });
                    // setNerge(arryDatass);

                     // Reset arryDatass before adding new data
            let updatedArray = [];

            res.data.data.meter_flow.forEach((x) => {
                updatedArray.push({
                    name: x[0]?.option || "",
                    Flow: x[0]?.flow || 0,
                });
            });

            setNerge(updatedArray);
    
                    console.log("nerge", nerge);
    
                    setLoading(false);
                });
        }
  

    const modalclick = (meter) => {
      setNerge([null]);

      if (!meter || !meter.id) {
        console.error("Invalid meter data:", meter);
        return; // Stop execution if meter is undefined
      }
      console.log("meter::",meter);
      
      setSelectedMeter(meter);
      setModalVisible(true);


      setLoading(true);
              setOpen(true);
            
                  var user = JSON.parse(localStorage.getItem("MCData"));
                  var userid = user?.userid;
              get(`apis/schematic_meter?meter_id=${meter.id}&user_id=${userid}`)
      
      
                  .then((res) => {
      
                      console.log(res.data.data.location[0]);
                      setRes(res.data.data);
                      setAccountname(res.data.data.account_name);
                      setUsage(res.data.data.meter_total_converted);
                      setUnit(res.data.data.unit);
                      setMeterid(res.data.data.meter_id);
                      setStatus(res.data.data.status);
                      setAddress(res.data.data.location[0].location_address_line1);
                      setAddressone(res.data.data.location[0].location_address_line2);
                      setAddresstwo(res.data.data.location[0].location_city);
                      setAddressthree(res.data.data.location[0].location_state);
                      setAddressfour(res.data.data.location[0].location_zip);
                      setWeekly(res.data.data.meter_notification_active.notification_status);
                      setregNo(res.data.data.location[0].register_number)
                      // res.data.data.meter_flow.map((x, i) => {
                      //     console.log(x);
      
                      //     let Obj = {
                      //         name: x?.option,
      
                      //         Flow: x?.flow,
      
      
                      //     };
      
                      //     arryDatass.push(Obj);
      
                      //     console.log("arryDatass", arryDatass);
      
      
      
                      // });
                      // setNerge(arryDatass);

                      const newData = res.data.data.meter_flow.map((x) => ({
                        name: x?.option,
                        Flow: x?.flow
                    }));
        
                    setNerge(newData);  // ✅ Set new state without mutation
      
                      
      
                      setLoading(false);
                  });
    };

    map.on("zoomend", handleZoom);

    // ✅ Always Visible Markers
    L.marker([locations.waterTank.lat, locations.waterTank.lng], {
      icon: tankIcon,
    })
      .addTo(map)
      .bindPopup(locations.waterTank.name);

    L.marker([locations.well.lat, locations.well.lng], { icon: wellIcon })
      .addTo(map)
      .bindPopup(locations.well.name);

    L.marker(
      [
        locations.non_potable_reservoir.lat,
        locations.non_potable_reservoir.lng,
      ],
      { icon: reservoirIcon }
    )
      .addTo(map)
      .bindPopup(locations.non_potable_reservoir.name);

    L.marker(
      [locations.non_potable_plant.lat, locations.non_potable_plant.lng],
      { icon: plantIcon }
    )
      .addTo(map)
      .bindPopup(locations.non_potable_plant.name);

    // locations.totalProducedMeters.forEach((producedMeter) => {
    //   L.marker([producedMeter.lat, producedMeter.lng], {
    //     icon: totalProducedIconVar,
    //   })
    //     .addTo(map)
    //     .bindPopup(producedMeter.name);
    // });

    return () => {
      map.off("zoomend", handleZoom);
      map.remove();
    };
  }, [locations]);

  // ✅ Function to Move Map to Marker
  const goToLocation = (lat, lng) => {
    if (mapInstance) {
      mapInstance.setView([lat, lng], 16);
    }
  };

  const onavigateToSchematics = () => {
    navigate('/schematics');

  }

  const onselectClickStats = () => {
    navigate('/stats');

}

const handleCancelss = () => {
  setNerge([null]);
  setOpensGPModal(false);
};

const onselectClicksDevices = () => {
  navigate('/devices');

}

const onselectClicksDemo = () => {
  navigate('/scematicsDemo');

}

const handleOk = () => {

};

const handleCancel = () => {
  
  setNerge([null]);

  setOpen(false);
};

const weeklyChange = (e) => {
      
        var id=e.target.id;
        setWeekly(e.target.checked);
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;
        console.log("print = ",regNo)
        if(regNo == null){
            setregNo('')
        }
        post(`apis/notification_meters_update?user_id=${userid}&meter_id=${id}&account_name=${accountname}&status=${e.target.checked}&register_number=${regNo}`).then(
            (response) => {
                // setdata(response.data.data);

                // toast.success('Added Audit Report Settings Successfully', {
                //     autoClose: 3000,
                // });

            }
        );
    };

  return (
    <div>
       {/* <head>
                <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"} </title></head> */}
            <Header />
            <Main className="bg-white">
              <div>
                                  <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex ">
                                      <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}}   />
                                          {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
                                          {/* <h3 className="mb-0">Schematic</h3> */}
                                          <div className='d-flex align-items-center'>
                                              <div className="new-box-padding  text-blue  align-self-center c-pointer "
                                              style={{    borderBottom: '2px solid #1998f0',
                                              borderRadius: '0'}}
                                              onClick={onavigateToSchematics}>
                                                  {/* <BranchesOutlined className="me-1" /> */}
                                                  Digital Twin </div>
                                              <div className="" style={{width: '2px', height: '25px', background: '#ccc' }}></div>
                                              <div className="new-box-padding   align-self-center c-pointer "  style={{
                                                                                      borderBottom: '2px solid #ccc',
                                                                                  }}
                                              onClick={onselectClickStats}>
                                                  
                                                  {/* <BarChartOutlined className="me-1" /> */}
                                                  
                                                  Stats </div>
                                              <div className="" style={{width: '2px', height: '25px', background: '#ccc' }}></div>
                                              <div className="new-box-padding   align-self-center c-pointer "  style={{
                                                                                  borderBottom: '2px solid #ccc',
                                                                              }}
                                              onClick={onselectClicksDevices}>
                                              {/* <DashboardOutlined title="Meter" className="me-1" /> */}
                                              
                                               Meters</div>
              
                                               <div className="new-box-padding   align-self-center c-pointer "  style={{
                                                                                  borderBottom: '2px solid #ccc',
                                                                              }}
                                              onClick={onselectClicksDemo}>
                                              {/* <DashboardOutlined title="Meter" className="me-1" /> */}
                                              
                                               Demo</div>
              
                                          </div>
                                      </div>
                                      </div>
                                      </div>
              
                                    
      <div id="map" style={{ height: "100vh", width: "100%" }}></div>

      {/* ✅ Modal for displaying meter details */}
      {/* <Modal
        title="Meter Details"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        {selectedMeter && (
          <div>
            <p><strong>Meter ID:</strong> {selectedMeter.id}</p>
            <p><strong>Name:</strong> {selectedMeter.name}</p>
            <p><strong>Latitude:</strong> {selectedMeter.lat}</p>
            <p><strong>Longitude:</strong> {selectedMeter.lng}</p>
          </div>
        )}
      </Modal> */}

      {open === true ?
                        <Modal
                            width={800}
                            title=""
                            open={open}
                            onOk={handleOk}


                            onCancel={handleCancel}
                            centered="true" className="selectCheckbox">
                            {loading ? <Spin /> : <>
                                <br />
                                <div className="d-flex justify-content-between align-items-center  px-0">
                                    <div className="px-0 fs-4">
                                    {/* <Checkbox ><p><font color="FFA500">Add {meterid} meter to alert</font></p></Checkbox> */}
                                        <h5 className="text-blue mb-0"> Meter Usage </h5>
                                        <p className="">[Last 30 Days]</p>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-100"> {usage}  </h5>
                                        <p className="txt-gallonNew"> {unit}</p>
                                    </div>
                                </div>
                                <LineChart
                                    width={765}
                                    height={300}
                                    data={nerge}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="Flow" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />

                                </LineChart>
                                <div className='labelYAxis5'>Gallons</div>
                               
                                
                                <div className="col text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterid}</div><br/>
                                <Checkbox id={meterid} onChange={weeklyChange} checked={weekly}><p className="mb-0"><font>Add to alert</font> </p></Checkbox>
                                </div>
                              
                                
                                <div className="row mt-2 fs-20 checkboxGreen">
                                    <div className="divnew">
                                        <h5 className="my-1 px-1">Status</h5>
                                        {res.status.length == 0 ? <><span class="badge bg-success ">Good</span>

                                        </> : ""}
                                        {res.status.map((item, index) => (
                                            <>
                                             {
                                                        // item.toLowerCase().includes('leak detected') ?
                                                        res.impact<=.2?<>
                                                        <span class="yellownoti">{res?.status[index]}</span><br/></>
                                                            
                                                            :
                                                            res.impact<=.4 &&  res.impact>.2 ?<>
                                                            <span class="orangenoti">{res?.status[index]}</span><br /></>
                                                            :
                                                            <><span class="rednoti">{res?.status[index]}</span><br /></>
                                                    }
                                                {/* <span class="badge bg-warning rounded-0">{res?.status[index]}</span><br /> */}
                                            </>

                                        ))}


                                    </div>
                                </div>
                                <div className="text-black px-0 my-2 included-outliers bg-gray px-1">Account Name <div className="float-right popupalignment"> <div>{accountname}</div></div></div>
                                <div className="text-black px-0 included-outliers bg-gray px-1">Location Address</div>
                                <div>
                                    <div className="my-2 px-1">{address}<br />
                                        {addressone}<br />
                                        {addresstwo}<br />
                                        {addressthree}<br />
                                        {addressfour}</div>
                                </div></>}

                        </Modal>
                        : ""}

                        {opensGPModal === true ?
                                                <Modal
                                                    width={800}
                                                    title=""
                                                    open={opensGPModal}
                                                    onOk={handleOk}
                        
                        
                                                    onCancel={handleCancelss}
                                                    centered="true" className="selectCheckbox">
                                                    {loading ? <Spin /> : <>
                                                        <br />
                                                        <div className="d-flex justify-content-between align-items-center  px-0">
                                                            <div className="px-0 fs-4">
                                                                <h5 className="text-blue mb-0"> {name==="Produced"?"Total Produced":name==="NPS1"?"114477/114476 ":"129122/129123 "}</h5>
                                                                <p className="">[Last 30 Days]</p>
                                                            </div>
                                                            <div>
                                                                <h5 className="mb-0 font-weight-100"> {usage}  </h5>
                                                                <p className="txt-gallonNew"> {unit}</p>
                                                            </div>
                                                        </div>
                                                        <LineChart
                                                            width={765}
                                                            height={300}
                                                            data={nerge}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 20,
                                                                bottom: 5,
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Line type="monotone" dataKey="Flow" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />
                        
                                                        </LineChart>
                                                        <div className='labelYAxis5'>Gallons</div>
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <div className="text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterid}</div></div>
                                                                <div className="row mt-2 fs-20 checkboxGreen">
                                                                    <div className="divnew">
                                                                        <h5 className="my-1">Status</h5>
                                                                        {res?.data_meters[0]?.status?.length == 0 ? <span class="badge bg-success ">Good</span> : ""}
                                                                        {res?.data_meters[0]?.status?.map((item, index) => (
                                                                            <>
                                                                             {
                                                                                // item.toLowerCase().includes('leak detected') ?
                                                                                res.data_meters[0].impact<=.2?<>
                                                                                <span class="yellownoti ">{res?.data_meters[0]?.status[index]}</span><br/></>
                                                                                    
                                                                                    :
                                                                                    res.data_meters[0].impact<=.4 &&  res.data_meters[0].impact>.2 ?<>
                                                                                    <span class="orangenoti ">{res?.data_meters[0]?.status[index]}</span><br /></>
                                                                                    :
                                                                                    <><span class="rednoti ">{res?.data_meters[0]?.status[index]}</span><br /></>
                                                                            }</>
                                                                            
                                                                            // <>
                                                                            //     <span class="badge bg-warning rounded-0">{res?.data_meters[0]?.status[index]}</span><br />
                                                                            // </>
                        
                                                                        ))}
                        
                        
                                                                    </div>
                                                                </div>
                                                                <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between"><div>Account Name </div><div className="popupalignment"> {accountname}</div></div>
                                                                <div className="text-black px-1 included-outliers bg-gray">Location Address</div>
                                                                <div>
                                                                    <div className="my-2 ">{address}<br />
                                                                        {addressone}<br />
                                                                        {addresstwo}<br />
                                                                        {addressthree}<br />
                                                                        {addressfour}</div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterids}</div></div>
                                                                <div className="row mt-2 fs-20 checkboxGreen">
                                                                    <div className="divnew">
                                                                        <h5 className="my-1">Status</h5>
                                                                        {res?.data_meters[1]?.status?.length == 0 ? <><span class="badge bg-success ">Good</span>
                        
                                                                        </> : ""}
                                                                        {res?.data_meters[1]?.status?.map((item, index) => (
                                                                            <>
                                                                             {
                                                                                // item.toLowerCase().includes('leak detected') ?
                                                                                res.data_meters[1].impact<=.2?<>
                                                                                <span class="yellownoti  ">{res?.data_meters[1]?.status[index]}</span><br/></>
                                                                                    
                                                                                    :
                                                                                    res.data_meters[1].impact<=.4 &&  res.data_meters[1].impact>.2 ?<>
                                                                                    <span class="orangenoti ">{res?.data_meters[1]?.status[index]}</span><br /></>
                                                                                    :
                                                                                    <><span class="rednoti ">{res?.data_meters[1]?.status[index]}</span><br /></>
                                                                            }
                                                                                {/* <span class="badge bg-warning rounded-0">{res?.data_meters[1]?.status[index]}</span><br /> */}
                                                                            </>
                        
                                                                        ))}
                        
                        
                                                                    </div>
                                                                </div>
                                                                <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between"> <div>Account Name</div> <div className="popupalignment"> {accountnames}</div></div>
                                                                <div className="text-black px-1 included-outliers bg-gray">Location Address</div>
                                                                <div>
                                                                    <div className="my-2 ">{addresss}<br />
                                                                        {addressones}<br />
                                                                        {addresstwos}<br />
                                                                        {addressthrees}<br />
                                                                        {addressfours}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>}
                        
                                                </Modal>
                                                : ""}
      </Main>
    </div>
  );
};

export default WaterSchematicMap;
